(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cl-collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-collection-description')) {
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.full = this.querySelector('[data-cl-intro-full]');
        this.box = this.querySelector('[data-cl-intro-text]');
        this.button = this.querySelector('[data-cl-intro-toggle]');
        if (!this.full || !this.box || !this.button) return;
        this.preview = this.querySelector('[data-cl-intro-preview]');
        if (!this.preview) {
          const text = this.full.innerText.replace(/\s+/g, ' ').trim();
          if (!Intl.Segmenter) return;
          const sentences = [...new Intl.Segmenter(document.documentElement.lang || 'en-GB', { granularity: 'sentence' }).segment(text)];
          if (sentences.length <= 2) return;
          this.preview = document.createElement('p');
          this.preview.dataset.clIntroPreview = '';
          this.preview.textContent = sentences.slice(0, 2).map(part => part.segment).join('').trim();
          this.box.prepend(this.preview);
          this.full.hidden = true;
          this.button.hidden = false;
        }
        this.opened = !this.full.hidden;
        this.button.addEventListener('click', () => this.toggle(), { signal: this.events.signal });
      }
      toggle() {
        const height = this.box.getBoundingClientRect().height;
        this.animation?.cancel();
        this.opened = !this.opened;
        this.full.hidden = !this.opened;
        this.preview.hidden = this.opened;
        this.button.setAttribute('aria-expanded', String(this.opened));
        this.button.setAttribute('aria-label', this.opened ? this.dataset.collapseLabel : this.dataset.expandLabel);
        this.button.querySelector('span').textContent = this.opened ? '\u2212' : '+';
        const target = this.box.getBoundingClientRect().height;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.box.style.overflow = 'hidden';
        const animation = this.box.animate([{ height: `${height}px` }, { height: `${target}px` }], { duration: 300, easing: 'ease-in-out' });
        this.animation = animation;
        animation.finished.then(() => {
          if (this.animation !== animation) return;
          this.box.style.overflow = '';
          this.animation = null;
        }).catch(() => {});
      }
      disconnectedCallback() {
        this.events?.abort(); this.events = null;
        this.animation?.cancel(); this.animation = null;
        if (this.box) this.box.style.overflow = '';
      }
    }
    customElements.define('cl-collection-description', CollectionDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
